// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import React from 'react'
import PathSummaryHeader from './PathSummaryHeader'

// NOTE - if you're looking for the 'band' heading,
// go to SiteNameHeader.js

class PathInfoHeader extends PathSummaryHeader {
  pathIndexStyle = {
    marginRight: '8px',
    paddingLeft: '8px',
    width: '30px',
  }

  wrapperStyle = { paddingLeft: 0 }

  sortByIndex = e => this.assignSort(e, 'pathIndex')
  sortByPathName = e => this.assignSort(e, 'pathName')

  render () {
    const {
      pathIndexStyle,
      props: { idRoot },
      sortByIndex,
      sortByPathName,
      sortIcon,
      wrapperStyle,
    } = this

    return (
      <div
        className={'display-flex'}
        style={wrapperStyle}>
        <span
          className={'path-summary-heading-trigger-index position-relative padding-half'}
          id={`${idRoot}path-index`}
          onClick={sortByIndex}
          style={pathIndexStyle}>
          {'#'}
          {sortIcon('pathIndex')}
        </span>
        <span
          className={'path-summary-heading-trigger-path-name position-relative padding-half padding-right-1 path-summary-heading-path-name'}
          id={`${idRoot}path-name`}
          onClick={sortByPathName}>
          {'Path'}
          {sortIcon('pathName')}
        </span>
      </div>
    )
  }
}

export default PathInfoHeader
